import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class ToggleAdministrableService {
    public observer: EventEmitter<boolean> = new EventEmitter();
    constructor() {}
}
